export const EVENTS = {
	BLUR: 'blur',
	FOCUS_OUT: 'focusout',
	CHANGE: 'change',
}

export const VALIDATION_MODE = {
	onBlur: 'onBlur',
	onChange: 'onChange',
	onSubmit: 'onSubmit',
	onTouched: 'onTouched',
	all: 'all',
}

export const getValidationModes = (mode) => ({
	isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
	isOnBlur: mode === VALIDATION_MODE.onBlur,
	isOnChange: mode === VALIDATION_MODE.onChange,
	isOnAll: mode === VALIDATION_MODE.all,
	isOnTouch: mode === VALIDATION_MODE.onTouched,
})

export const skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
	if (mode.isOnAll) {
		return false
	} else if (!isSubmitted && mode.isOnTouch) {
		return !(isTouched || isBlurEvent)
	} else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
		return !isBlurEvent
	} else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
		return isBlurEvent
	}
	return true
}
